/**
 * 로그인 만료 알림 통로 — 서버가 401 을 돌려주면 **화면이 알아채게** 한다.
 *
 * 앱을 여는 순간에만 세션을 확인했더니(AppInitializer), 열어 둔 채로 세션이 끊기면 앱은 여전히 로그인
 * 상태라고 믿고 서버는 401 만 돌려주어 **프로젝트·캔버스가 조용히 비어 보였다**(현장 2026-09-23:
 * "프로젝트 목록은 남아 있는데 다이어그램이 비어 있다" — 무엇이 잘못됐는지 알 길이 없었다).
 *
 * 부르는 곳: QBase 호출(qbaseClient) · 오픈플로우 백엔드(config/api be1Fetch) · 어시스턴트(assistantClient).
 * 받는 곳: SessionExpiredDialog 가 화면 위에 다시 로그인 창을 띄운다(캔버스는 그대로 둔다).
 *
 * 스토어를 직접 부르지 않고 등록된 함수를 부른다 — services ↔ store 순환 import 를 만들지 않기 위해서다.
 */
type Handler = (where?: string) => void;

let handler: Handler | null = null;

/** 화면 쪽에서 한 번 등록한다 (SessionExpiredDialog) */
export function onUnauthorized(fn: Handler | null): void {
  handler = fn;
}

/** 401 을 만났다 — 어디에서였는지(경로)는 기록·표시에만 쓴다 */
export function notifyUnauthorized(where?: string): void {
  handler?.(where);
}
